class AuthUI {
    constructor() {
        this.initialized = false;

    }

    init() {
        if (this.initialized) return;
        this.initialized = true;

        const sceneEl = document.querySelector('a-scene');
        if (sceneEl.hasLoaded) {
            this.registerPopups();
        } else {
            sceneEl.addEventListener('loaded', () => this.registerPopups());
        }

        this.attachEventListeners();
    }

    registerPopups() {
        if (!window.PopupManager) return;

        const popups = [
            { id: 'authorization-pop-up', yOpen: 2.3, zOpen: -1 },
            { id: 'account-pop-up', yOpen: 2.5, zOpen: -1 },
            { id: 'complete-account-pop-up', yOpen: 2.3, zOpen: -0.9 },
            { id: 'reset-password-pop-up', yOpen: 2.3, zOpen: -0.95 },
            { id: 'account-set-new-password', yOpen: 2.3, zOpen: -1 },
            { id: 'delete-account-pop-up', yOpen: 2.3, zOpen: -0.9 }
        ];

        popups.forEach(p => {
            const el = document.getElementById(p.id);
            if (el) {
                window.PopupManager.register(p.id, el, {
                    onOpen: () => {
                        el.setAttribute('position', `0 ${p.yOpen} ${p.zOpen}`);
                        el.setAttribute('visible', 'true');
                    },
                    onClose: () => {
                        el.setAttribute('position', `0 ${p.yOpen + 10} ${p.zOpen}`);
                        el.setAttribute('visible', 'false');
                    }
                });
            }
        });
    }

    createAuthCard() {
        // now need to create the auth card
    }   
    

    updateUI(session, displayName = 'Guest') {
        console.log('updateUI', session)
        const mainAuthBtn = window.AuthUI.getElements().mainAuthBtn;
        const mainAccountBtn = window.AuthUI.getElements().mainAccountBtn;
        const loginText = document.querySelector('#top-menu-container .login-text')
        const accountPopUp = document.querySelector('#account-pop-up')
        
        if (session) {
            const user = session?.user;
            const email = user?.email;
            const name = user?.user_metadata?.display_name;
            const nameToDisplay = name ||  email || 'Guest';
            const aid = user?.id ? String(user.id).slice(-6).toUpperCase() : '';
            const did = session.device_id ? String(session.device_id).slice(-6).toUpperCase() : null;
            const shortNameToDisplay = nameToDisplay.length > 24 ? nameToDisplay.slice(0, 24) + '...' : nameToDisplay;
            
            const displayedNameText =  window.AuthUI.getElements().displayedNameText
            const displayedNameInput =  window.AuthUI.getElements().displayedNameInput
            const userIdsText = window.AuthUI.getElements().displayedIdsText
            
            if (displayedNameText) {
                displayedNameText.setAttribute('value', shortNameToDisplay);
                displayedNameText.dataset.rawName = nameToDisplay;
                displayedNameText.dataset.aid = aid;
            }
            if (userIdsText) {
                const idString = aid ? `AID: ${aid}${did ? ' / DID: ' + did : ''}` : '';
                userIdsText.setAttribute('value', idString);
            }
            if (displayedNameInput) displayedNameInput.setAttribute('value', nameToDisplay)

            if (mainAuthBtn && mainAccountBtn) {
                mainAuthBtn.removeAttribute('data-raycastable');
                mainAccountBtn.setAttribute('data-raycastable', 'true');
            }
            if (loginText) {
                loginText.setAttribute('value', 'Account')
            }

            const loginIcon = document.querySelector('#account-button-icon')
            if (loginIcon) {
                loginIcon.setAttribute('src', '#account-icon-asset')
            }

            if (accountPopUp) {
                const isAnonymousUser = session.user.is_anonymous
                window.AuthUI.switchAccountView(isAnonymousUser)
            }

            if (window.gtag) gtag('event', `VR_TopNav_Account_LogIn`);
        } else {
            window.AuthUI.closeAccountModal()
            if (mainAuthBtn && mainAccountBtn) {
                mainAccountBtn.removeAttribute('data-raycastable');
                mainAuthBtn.setAttribute('data-raycastable', 'true');
            }
            if (loginText) {
                loginText.setAttribute('value', 'Log In')
            }

            const loginIcon = document.querySelector('#account-button-icon')
            if (loginIcon) {
                loginIcon.setAttribute('src', '#login-icon-asset')
            }

            if (window.gtag) gtag('event', `VR_TopNav_Account_LogOut`);
        }
    }
    
    
    updateButtonState(consentGiven, supabaseReady) {
        // button control
        console.log('updateButtonState', consentGiven)
        const consentElement = document.querySelector('#cookie-consent-container');
        if (consentElement) {
            consentElement.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: {consentGiven} }));
            
            // fallback
            consentElement.setAttribute('cookie-consent', {
                isShow: !consentGiven
            })
        }
        
        window.AuthUI.getElements().mainAuthBtn.dataset.restricted = String(!consentGiven)
        window.AuthUI.getElements().mainAccountBtn.dataset.restricted = String(!consentGiven)
    }

    attachEventListeners() {
        // click auth button
        const authBtn = window.AuthUI.getElements().mainAuthBtn;
        if (authBtn) {
            authBtn.addEventListener('click', () => {
                if (authBtn.dataset.restricted === 'true') {
                    // window.WatchlistApp.Popup.showNotificationPopup('Login Restricted', 'You can not log in until accept the cookies');
                    const consentElement = document.querySelector('#cookie-consent-container');
                    if (consentElement) consentElement.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: {consentGiven: false} }));
                } else {
                    window.AuthUI.showAuthModal();
                }
            });
        }
        // click account button
        const accountBtn = window.AuthUI.getElements().mainAccountBtn;
        if (accountBtn) {
            accountBtn.addEventListener('click', () => {
                if (accountBtn.dataset.restricted === 'true') {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies')
                    const consentElement = document.querySelector('#cookie-consent-container');
                    if (consentElement) consentElement.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: {consentGiven: false} }));
                } else {
                    window.AuthUI.showAccountModal()
                }
            });
        }


        // close auth modal
        const authModalCloseButton = document.querySelector('#authorization-pop-up .close-button');
        if (authModalCloseButton) authModalCloseButton.addEventListener('click', window.AuthUI.closeAuthModal);
        // close account modal
        const accountModalCloseButton = document.querySelector('#account-pop-up .close-button');
        if (accountModalCloseButton) accountModalCloseButton.addEventListener('click', window.AuthUI.closeAccountModal);


        // // switch between sign in and sign up
        const tipButton = document.querySelector('#authorization-pop-up .tip-button');
        if (tipButton) tipButton.addEventListener('click', window.AuthUI.switchAuthAndRegModal)
        

        // reset password popup - close 
        const resetPasswordPopUpCloseButton = document.querySelector('#reset-password-pop-up .close-button');
        if (resetPasswordPopUpCloseButton) resetPasswordPopUpCloseButton.addEventListener('click', window.AuthUI.closeResetRequestModal)

        // set new password popup - close 
        const setNewPasswordPopUpCloseButton = document.querySelector('#account-set-new-password .close-button');
        if (setNewPasswordPopUpCloseButton) setNewPasswordPopUpCloseButton.addEventListener('click', window.AuthUI.closeResetUpdateModal)


        // complete account pop-up close
        const closeCompleteAccountPopUp = document.querySelector('#complete-account-pop-up .close-button')
        if (closeCompleteAccountPopUp) closeCompleteAccountPopUp.addEventListener('click', window.AuthUI.closeUpgradeModal)

        // close profile popup after opening completeAccountPopUp
        const dropdownRegisterBtn = window.AuthUI.getElements().dropdownRegisterBtn
        if (dropdownRegisterBtn) dropdownRegisterBtn.addEventListener('click', window.AuthUI.closeAccountModal)


        // close info message
        const accountInfoButton = document.querySelector("#account-info-message-pop-up .close-button");
        if (accountInfoButton) accountInfoButton.addEventListener('click', window.AuthUI.hideMessage)

        // emulate profileUpdateForm submit 
        const profileUpdateForm = window.AuthUI.getElements().profileUpdateForm;
        const profileUpdateFormButtonReal = document.querySelector('#account-pop-up .change-name-button')
        const profileUpdateFormButtonHelper =window.AuthUI.getElements().profileUpdateFormButton;
        if (profileUpdateForm &&  profileUpdateForm.requestSubmit && profileUpdateFormButtonReal && profileUpdateFormButtonHelper) {
            profileUpdateFormButtonReal.addEventListener('click', () => {
                if ( profileUpdateFormButtonHelper.disabled) return
                profileUpdateForm.requestSubmit()
            })
        }


        // emulate resetRequestForm submit 
        const resetRequestForm = window.AuthUI.getElements().resetRequestForm;
        const resetRequestFormButtonReal = document.querySelector('#reset-password-pop-up .send-reset-password')
        const resetRequestFormButtonHelper = window.AuthUI.getElements().sendResetLinkBtn;
        if (resetRequestForm &&  resetRequestForm.requestSubmit && resetRequestFormButtonReal && resetRequestFormButtonHelper) {
            resetRequestFormButtonReal.addEventListener('click', () => {
                if (resetRequestFormButtonHelper.disabled) return
                resetRequestForm.requestSubmit()
            })
        }
        

        // emulate upgradeForm (complete account) submit 
        const upgradeForm = window.AuthUI.getElements().upgradeForm;
        const upgradeFormButtonReal = document.querySelector('#complete-account-pop-up .complete-account')
        const upgradeFormButtonHelper = window.AuthUI.getElements().completeAccountBtn;
        if (upgradeForm &&  upgradeForm.requestSubmit && upgradeFormButtonReal && upgradeFormButtonHelper) {
            upgradeFormButtonReal.addEventListener('click', () => {
                if (upgradeFormButtonHelper.disabled) return
                upgradeForm.requestSubmit()
            })
        }

        // emulate upgradeForm (set new password) submit 
        const resetUpdateForm = window.AuthUI.getElements().resetUpdateForm;
        const resetUpdateFormButtonReal = document.querySelector('#account-set-new-password .set-new-password')
        const resetUpdateFormButtonHelper = window.AuthUI.getElements().resetPasswordSubmitBtn;
        if (resetUpdateForm &&  resetUpdateForm.requestSubmit && resetUpdateFormButtonReal && resetUpdateFormButtonHelper) {
            resetUpdateFormButtonReal.addEventListener('click', () => {
                if (resetUpdateFormButtonHelper.disabled) return
                resetUpdateForm.requestSubmit()
            })
        }
        
        
        // gtag events
        window.AuthUI.getElements().resetRequestForm?.addEventListener('submit', () => {
            if (window.gtag) window.gtag('event', 'VR_TopNav_Account_ResetPW');
        });
        
        window.AuthUI.getElements().signupBtn?.addEventListener('click', () => {
            if (window.gtag) window.gtag('event', 'VR_TopNav_Account_NewAccount');
        })
    }
    
    switchAccountView(isAnonymous) {
        const completeAccountButton = document.querySelector('#account-pop-up .complete-account');
        const deleteAccountButton = document.querySelector('#account-pop-up .delete-account');
        
        if (isAnonymous) {
            if (completeAccountButton) completeAccountButton.setAttribute('visible', 'true')
            if (completeAccountButton) completeAccountButton.setAttribute('position', '0 -1.2 0.01')
            if (deleteAccountButton) deleteAccountButton.setAttribute('visible', 'false')
            if (deleteAccountButton) deleteAccountButton.setAttribute('position', '0 -21.2 0.01')
        } else {
            if (completeAccountButton) completeAccountButton.setAttribute('visible', 'false')
            if (completeAccountButton) completeAccountButton.setAttribute('position', '0 -21.2 0.01')
            if (deleteAccountButton) deleteAccountButton.setAttribute('visible', 'true')
            if (deleteAccountButton) deleteAccountButton.setAttribute('position', '0 -1.2 0.01')
        }
    }
    
    
    switchAuthAndRegModal() {
        const authPopUp = document.querySelector('#authorization-pop-up');
        if (!authPopUp) return
        const wasAuth = authPopUp.dataset.type === 'auth';
        
        const authTitle = authPopUp.querySelector('.auth-title');
        const tipText = authPopUp.querySelector('.tip-text');
        const resetPasswordText = authPopUp.querySelector('.reset-password-text');
        const resetPasswordPlane = authPopUp.querySelector('.reset-password-text');
        const loginButton = authPopUp.querySelector('.login');
        const registerButton = authPopUp.querySelector('.register');
        const passwordConfirmWrapper = authPopUp.querySelector('.password-confirm-wrapper');
        
        const bgSmall = authPopUp.querySelector('.popup-bg-small')
        const bgBig = authPopUp.querySelector('.popup-bg-big')
        const leftContent = authPopUp.querySelector('.left-content')
        const rightContent = authPopUp.querySelector('.right-content')
        const closeButtonWrapper = authPopUp.querySelector('.close-button-wrapper')
        const dividerLine = authPopUp.querySelector('.divider-line')
        
        if (wasAuth) {
            authTitle.setAttribute('value', 'Welcome!')
            tipText.setAttribute('value', 'Login now')
            authPopUp.dataset.type = 'reg'
            resetPasswordText.setAttribute('visible', 'false')
            resetPasswordPlane.removeAttribute('data-raycastable')
            loginButton.setAttribute('visible', 'false')
            loginButton.setAttribute('position', '0 -20.9 0.01')
            registerButton.setAttribute('visible', 'true')
            registerButton.setAttribute('position', '0 -0.9 0.01')
            passwordConfirmWrapper.setAttribute('visible', 'true')
            passwordConfirmWrapper.setAttribute('position', '-1.5 0.1 0.01')


            bgBig.setAttribute('visible', 'false')
            bgSmall.setAttribute('visible', 'true')
            leftContent.setAttribute('position', '0 0 0')
            rightContent.setAttribute('visible', 'false')
            closeButtonWrapper.setAttribute('position', '1.5 1.96 0.01')
            dividerLine.setAttribute('visible', 'false')
        } else {
            authTitle.setAttribute('value', 'Lets continue!')
            tipText.setAttribute('value', 'Register now')
            authPopUp.dataset.type = 'auth'
            resetPasswordText.setAttribute('visible', 'true')
            resetPasswordPlane.setAttribute('data-raycastable', 'true')
            registerButton.setAttribute('visible', 'false')
            registerButton.setAttribute('position', '0 -20.9 0.01')
            loginButton.setAttribute('visible', 'true')
            loginButton.setAttribute('position', '0 -0.9 0.01')
            passwordConfirmWrapper.setAttribute('visible', 'false')
            passwordConfirmWrapper.setAttribute('position', '-21.5 0.1 0.01')

            bgSmall.setAttribute('visible', 'false')
            bgBig.setAttribute('visible', 'true')
            leftContent.setAttribute('position', '-1.9 0 0')
            rightContent.setAttribute('visible', 'true')
            closeButtonWrapper.setAttribute('position', '3.3 1.96 0.01')
            dividerLine.setAttribute('visible', 'true')
        }
    }
    
    
    showAuthModal() {
        if (window.PopupManager) {
            window.PopupManager.open('authorization-pop-up');
        } else {
            const authModal = document.getElementById('authorization-pop-up');
            if (authModal) {
                authModal.setAttribute('position', '0 2.3 -1')
                authModal.setAttribute('visible', 'true')
            }
        }
    }
    closeAuthModal() {
        if (window.PopupManager) {
            window.PopupManager.close('authorization-pop-up');
        } else {
            const authModal = document.getElementById('authorization-pop-up');
            if (authModal) {
                authModal.setAttribute('position', '0 12.3 -1')
                authModal.setAttribute('visible', 'false')
            }
        }
    }

    showAccountModal() {
        if (window.PopupManager) {
            window.PopupManager.open('account-pop-up');
        } else {
            const accountModal = document.getElementById('account-pop-up');
            if (accountModal) {
                accountModal.setAttribute('position', '0 2.5 -1')
                accountModal.setAttribute('visible', 'true')
            }
        }
    }
    closeAccountModal() {
        if (window.PopupManager) {
            window.PopupManager.close('account-pop-up');
        } else {
            const accountModal = document.getElementById('account-pop-up');
            if (accountModal) {
                accountModal.setAttribute('position', '0 12.5 -1')
                accountModal.setAttribute('visible', 'false')
            }
        }
    }
    
    toggleConfirmPasswordField(show) {
        // no need to toggle the confirm password field
    }

    showUpgradeModal() {
        if (window.PopupManager) {
            window.PopupManager.open('complete-account-pop-up');
        } else {
            const completeAccountPopUp = document.getElementById('complete-account-pop-up');
            if (completeAccountPopUp) {
                completeAccountPopUp.setAttribute('position', '0 2.3 -0.9')
                completeAccountPopUp.setAttribute('visible', 'true')
            }
        }
    }
    closeUpgradeModal() {
        if (window.PopupManager) {
            window.PopupManager.close('complete-account-pop-up');
        } else {
            const completeAccountPopUp = document.getElementById('complete-account-pop-up');
            if (completeAccountPopUp) {
                completeAccountPopUp.setAttribute('position', '0 12.3 -0.9')
                completeAccountPopUp.setAttribute('visible', 'false')
            }
        }
    }

    showResetRequestModal() {
        if (window.PopupManager) {
            window.PopupManager.open('reset-password-pop-up');
        } else {
            const resetPasswordPopUp = document.getElementById('reset-password-pop-up');
            if (resetPasswordPopUp) {
                resetPasswordPopUp.setAttribute('position', '0 2.3 -0.95')
                resetPasswordPopUp.setAttribute('visible', 'true')
            }
        }
    }
    closeResetRequestModal() {
        if (window.PopupManager) {
            window.PopupManager.close('reset-password-pop-up');
        } else {
            const resetPasswordPopUp = document.getElementById('reset-password-pop-up');
            if (resetPasswordPopUp) {
                resetPasswordPopUp.setAttribute('position', '0 12.3 -0.95')
                resetPasswordPopUp.setAttribute('visible', 'false')
            }
        }
    }
    showResetUpdateModal() {
        if (window.PopupManager) {
            window.PopupManager.open('account-set-new-password');
        } else {
            const setNewPasswordPopUp = document.getElementById('account-set-new-password');
            if (setNewPasswordPopUp) {
                setNewPasswordPopUp.setAttribute('position', '0 2.3 -1')
                setNewPasswordPopUp.setAttribute('visible', 'true')
            }
        }
    }
    closeResetUpdateModal() {
        if (window.PopupManager) {
            window.PopupManager.close('account-set-new-password');
        } else {
            const setNewPasswordPopUp = document.getElementById('account-set-new-password');
            if (setNewPasswordPopUp) {
                setNewPasswordPopUp.setAttribute('position', '0 12.3 -1')
                setNewPasswordPopUp.setAttribute('visible', 'false')
            }
        }
    }
    
    showDeleteAccountPopUp() {
        if (window.PopupManager) {
            window.PopupManager.open('delete-account-pop-up');
        } else {
            const deleteAccountModal = document.getElementById('delete-account-pop-up');
            if (deleteAccountModal) {
                deleteAccountModal.setAttribute('position', '0 2.3 -0.9')
                deleteAccountModal.setAttribute('visible', 'true')
            }
        }
    }
    closeDeleteAccountPopUp() {
        if (window.PopupManager) {
            window.PopupManager.close('delete-account-pop-up');
        } else {
            const deleteAccountModal = document.getElementById('delete-account-pop-up');
            if (deleteAccountModal) {
                deleteAccountModal.setAttribute('position', '0 12.3 -0.9')
                deleteAccountModal.setAttribute('visible', 'false')
            }
        }
    }

    getElements() {
        return {
            mainAuthBtn: document.querySelector("#top-menu-container .auth-button"), // +
            mainAccountBtn: document.querySelector("#top-menu-container .account-button"), // +
            signupBtn: document.querySelector('#authorization-pop-up .register'), // +
            signinBtn: document.querySelector('#authorization-pop-up .login'), // +
            dropdownSignoutBtn: document.querySelector('#account-pop-up .log-out'), // +
            dropdownDeleteBtn: document.querySelector('#delete-account-pop-up .confirm-delete-account'), // +
            email: document.querySelector('#authorization-pop-up input[name="email"]'),  // +
            password: document.querySelector('#authorization-pop-up input[name="password"]'), // +
            confirmPassword: document.querySelector('#authorization-pop-up input[name="password-confirm"]'), // +
            //
            // // profile update elements
            profileUpdateForm: document.querySelector('#account-pop-up form.name-control-block'), // +
            profileUpdateFormInput: document.querySelector('#account-pop-up  #display-user-name-input'), // +
            profileUpdateFormButton: document.querySelector('#account-pop-up .change-name-helper'), // +
            
            //
            // // New upgrade modal elements
            upgradeForm: document.querySelector('#complete-account-pop-up .upgrade-form'), // +
            upgradeEmail: document.querySelector('#complete-account-pop-up input[name="email"]'), // +
            upgradePassword: document.querySelector('#complete-account-pop-up input[name="password"]'), // +
            upgradeConfirmPassword: document.querySelector('#complete-account-pop-up input[name="password-confirm"]'), // +
            completeAccountBtn: document.querySelector('#complete-account-pop-up button.complete-account-helper'), // +
            googleUpgradeBtn: document.querySelector('#complete-account-pop-up .google-complete'), // +

            //
            dropdownRegisterBtn: document.querySelector('#account-pop-up .complete-account'), // +
            //
            googleSigninBtn: document.querySelector('#authorization-pop-up .google-login'), // +
            //
            // Password reset elements
            forgotPasswordLink: document.querySelector('#authorization-pop-up .reset-password-plane'), // +
            resetRequestForm: document.querySelector('#reset-password-pop-up .reset-password-form'), // +
            resetEmail: document.querySelector('#reset-password-pop-up input[name="email"]'), // +
            sendResetLinkBtn: document.querySelector('#reset-password-pop-up .send-reset-password-helper'), // +
            resetRequestMessage: document.querySelector('#reset-password-pop-up .reset-request-message'), // +
            
            resetUpdateForm: document.querySelector('#account-set-new-password .reset-update-form'), // +
            newPassword: document.querySelector('#account-set-new-password input[name="password"]'), // +
            confirmNewPassword: document.querySelector('#account-set-new-password input[name="password-confirm"]'), // +
            // resetUpdateMessage: document.querySelector('#account-set-new-password .reset-request-message'), // +
            resetPasswordSubmitBtn: document.querySelector('#account-set-new-password .set-new-password-helper'), // +

            displayedNameText: document.querySelector('#account-pop-up .current-user-name-text'), // +
            displayedIdsText: document.querySelector('#account-pop-up .user-ids-text'), // +
            displayedNameInput: document.querySelector('#account-pop-up #display-user-name-input'), // +
        };
    }

    showMessage(message, isError) {
        if (isError) console.error(message);
        else console.log(message);

        // Clear existing timer if any
        if (this.messageTimer) {
            clearTimeout(this.messageTimer);
            this.messageTimer = null;
        }

        const accountInfoPopup = document.querySelector("#account-info-message-pop-up");
        const accountInfoPopupText = document.querySelector("#account-info-message-pop-up .info-text");
        if (accountInfoPopup && accountInfoPopupText) {
            accountInfoPopup.setAttribute('visible', 'true');
            accountInfoPopup.setAttribute('position', '0 2.42 -0.2');
            accountInfoPopupText.setAttribute('value', message);

            // Auto-hide after 3 seconds
            this.messageTimer = setTimeout(() => {
                this.hideMessage();
                this.messageTimer = null;
            }, 2000);
        }
    }
    renderInlineMessage(container, text, type) {
        window.AuthUI.showMessage(text, type === 'error');
    }
    
    hideMessage() {
        const accountInfoPopup = document.querySelector("#account-info-message-pop-up");
        if (accountInfoPopup) {
            accountInfoPopup.setAttribute('visible', 'false');
            accountInfoPopup.setAttribute('position', '0 12.42 -0.2');
        }
    }

}
// Create global instance
window.AuthUI = new AuthUI();

// Auto-initialize when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.AuthUI.init();
    });
} else {
    window.AuthUI.init();
}    